@if (config) {
  <wl-progressive-form-container [config]="config">
  </wl-progressive-form-container>
}
